import { Icon } from 'components';
import React, { memo, useCallback } from 'react';
import ReactPaginate from 'react-paginate';

import * as Styles from './styles';

interface IProps {
  pagesCount: number;
  pageRangeDisplayed?: number;
  marginPagesDisplayed?: number;
  initialPage?: number;
  disableInitialCallback?: boolean;
  onChange?(newPage: number): void;
}

const PaginationComponent: React.FC<IProps> = ({
  pagesCount,
  pageRangeDisplayed = 5,
  marginPagesDisplayed = 2,
  initialPage = 1,
  disableInitialCallback = false,
  onChange,
}) => {
  const handleChangePage = useCallback(
    ({ selected }: { selected: number }) => {
      onChange?.(selected + 1);
    },
    [onChange],
  );

  return (
    <Styles.Container>
      <ReactPaginate
        previousLabel={<Icon name="arrowLeft" size={1.7} color="gray400" />}
        nextLabel={<Icon name="arrowRight" size={1.7} color="gray400" />}
        breakLabel={'...'}
        pageCount={pagesCount}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        onPageChange={handleChangePage}
        initialPage={initialPage - 1}
        disableInitialCallback={disableInitialCallback}
        pageClassName={'page'}
        breakClassName={'break'}
        activeClassName={'active'}
        disabledClassName={'disabled'}
        containerClassName={'pagination'}
      />
    </Styles.Container>
  );
};

export const Pagination = memo(PaginationComponent);
